<template>
  <CarouselSlide class="feedback-slide">
    <div class="user-feedback-wrapper">
      <div class="user-feedback">
        <p class="user-feedback__text" v-html="feedback.content"></p>
      </div>
      <p class="user-feedback__name">{{ feedback.name }}</p>
      <p class="user-feedback__description">{{ feedback.additional_info }}</p>
      <div class="user-feedback__rating-box">
        <ul class="user-feedback__rating">
          <li v-for="index in feedback.rating" :key="index" class="user-feedback__star"><StarIcon /></li>
        </ul>
      </div>
    </div>
  </CarouselSlide>
</template>

<script>
import { StarIcon } from '@/shared/ui/icons';
import { CarouselSlide } from '@/shared/ui/slider';

export default {
  props: {
    feedback: {
      type: Object,
      required: true,
    },
  },
  components: { CarouselSlide, StarIcon },
};
</script>

<style lang="scss" scoped>
.user-feedback {
  &-wrapper {
    position: relative;
  }

  &__text {
    position: relative;
    background-color: #FFFFFF;
    font-family: 'Inter', sans-serif;
    font-size: 24px;
    font-weight: 400;
    color: #313437;
    padding: 35px;
    border-radius: 35px;
    box-shadow: -28.35px 76.65px 62.31px 0px #495A9514, 0px 17.04px 33.7px 0px #7490BC1C;

    &::after {
      content: "";
      position: absolute;
      width: 46px;
      height: 46px;
      bottom: -35px;
      left: 140px;
      background-color: #FFFFFF;

      --r:5px;
      aspect-ratio: 1;
      border-top-left-radius: var(--r);
      clip-path: polygon(0 100%,100% 0,0 0);
      --_g:calc(50%*(1 + 1/tan(22.5deg)) - var(--r)/(3*sqrt(2) - 4));
      --_r:calc(var(--r)/tan(22.5deg)),#000 98%,#0000 101%;
      mask:
        radial-gradient(var(--r) at top  var(--r) right  var(--_r)),
        radial-gradient(var(--r) at left var(--r) bottom var(--_r)),
        conic-gradient(from -67.5deg at var(--_g) var(--_g),#000 45deg,#0000 0);
      -webkit-mask:
        radial-gradient(var(--r) at top  var(--r) right  var(--_r)),
        radial-gradient(var(--r) at left var(--r) bottom var(--_r)),
        conic-gradient(from -67.5deg at var(--_g) var(--_g),#000 45deg,#0000 0);

      box-shadow: -28.35px 76.65px 62.31px 0px #495A9514, 0px 17.04px 33.7px 0px #7490BC1C;
    }
  }

  &__name {
    font-family: "IBM Plex Sans", sans-serif;
    font-size: 32px;
    font-weight: 500;
    color: #313437;
    margin-bottom: 0;
  }

  &__description {
    font-family: 'Inter', sans-serif;
    font-size: 18px;
    font-weight: 400;
    color: #494E53;
    margin-bottom: 0;
  }

  &__rating-box {
    position: absolute;
    bottom: 2px;
    right: 0;
  }

  &__rating {
    display: flex;
    align-items: center;
  }
}
</style>

